export default "__VITE_ASSET__CwTDhoOi__"